'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (global, factory) {
  (typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define('bulmaCalendarVanTot', factory) : global.bulmaCalendarVanTot = factory();
})(undefined, function () {
  'use strict';

  var datepicker_langs = {
    nl: {
      weekStart: 1,
      months: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
      monthsShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      weekdays: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
      weekdaysShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
    }
  };

  Element.prototype.addEventsListener = function (events, listener) {
    var _this = this;

    if (listener == undefined) {
      listener = function listener() { };
    }
    if (!Array.isArray(events)) {
      events = [events];
    }

    events.forEach(function (event) {
      _this.addEventListener(event, listener);
    });
  };

  var datePickerVanTot = function () {
    function datePickerVanTot(selector, options) {
      _classCallCheck(this, datePickerVanTot);

      if (options == undefined) {
        options = {};
      }

      // Determine click event depending on if we are on Touch device or not
      this._clickEvent = ['touchstart', 'click'];
      this._changeEvent = ['change'];
      this._hoverEvent = ['mouseenter'];
      this._hoverEndEvent = ['mouseleave'];

      this.element = typeof selector === 'string' ? document.querySelector(selector) : selector;
      // An invalid selector or non-DOM node has been provided.
      if (!this.element) {
        throw new Error('An invalid selector or non-DOM node has been provided.');
      }

      /// Set default options and merge with instance defined
      this.options = Object.assign({}, {
        startDate: null,
        endDate: null,
        dateFrom: null,
        dateTo: null,
        dateHover: null,
        minDateVan: null,
        maxDateVan: null,
        minDateTot: null,
        maxDateTot: null,
        dateFormat: 'yyyy-mm-dd', // the default data format `field` value
        lang: 'nl', // internationalization
        meetId: '',
        // callback functions
        onSelect: null,
        onReset: null
      }, options);

      // Initiate plugin
      this._init();
    }

    /**
     * Initiate plugin instance
     * @method _init
     * @return {datePickerVanTot} Current plugin instance
     */
    _createClass(datePickerVanTot, [{
      key: '_init',
      value: function _init() {
        this._id = 'datePicker' + new Date().getTime() + Math.floor(Math.random() * Math.floor(9999));
        this.lang = typeof datepicker_langs[this.lang] !== 'undefined' ? this.lang : 'nl';
        // If no dateFrom set the dates null, no selection
        if (this.options.dateFrom && this.options.dateTo) {
          this.options.startDate = this.options.dateFrom;
          this.options.endDate = this.options.dateTo;
        } else {
          this.options.startDate = null;
          this.options.endDate = null;
        }
        this.day = '';
        this.month = new Date().getMonth();
        this.year = new Date().getFullYear();

        if (this.options.minDateVan) {
          this.options.minDateVan = this._parseDate(this._getFormatedDate(this.options.minDateVan, this.options.dateFormat));
        }
        if (this.options.maxDateVan) {
          this.options.maxDateVan = this._parseDate(this._getFormatedDate(this.options.maxDateVan, this.options.dateFormat));
        }
        if (this.options.minDateTot) {
          this.options.minDateTot = this._parseDate(this._getFormatedDate(this.options.minDateTot, this.options.dateFormat));
        }
        if (this.options.maxDateTot) {
          this.options.maxDateTot = this._parseDate(this._getFormatedDate(this.options.maxDateTot, this.options.dateFormat));
        }

        this._build();
        this._bindEvents();

        return this;
      }

      /**
       * Build datePickerVanTot HTML component and append it to the DOM
       * @method _build
       * @return {datePickerVanTot} Current plugin instance
       */
    }, {
      key: '_build',
      value: function _build() {
        // Define datePickerVanTot Template
        var datePicker = '<div id="' + this._id + '" class="ols-datepicker ols-datepicker-van-tot">'
          + '<div class="ols-datepicker-months-container"><div class="ols-datepicker-months"><div class="ols-calendar ols-calendar1" id="ipoclick-radio-' + this.options.meetId + '-datum_gekozen">';
        datePicker += '<div class="calendar-container"><div class="calendar-nav-previous-month"></div><div class="calendar-month">'
          + datepicker_langs[this.options.lang].months[this.month] + '</div><div class="calendar-year">'
          + this.year + '</div><div class="calendar-header"><div class="calendar-date">'
          + this._getDayName(0, true) + '</div><div class="calendar-date">' + this._getDayName(1, true) + '</div><div class="calendar-date">'
          + this._getDayName(2, true) + '</div><div class="calendar-date">' + this._getDayName(3, true) + '</div><div class="calendar-date">'
          + this._getDayName(4, true) + '</div><div class="calendar-date">' + this._getDayName(5, true) + '</div><div class="calendar-date">'
          + this._getDayName(6, true) + '</div></div><div class="calendar-body"></div></div></div>';
        // ols-calendar2 rekening houden met december + januari
        var month = this.month + 1;
        var year = this.year;
        if (month > 11) {
          month = 0;
          year = year + 1;
        }
        datePicker += '<div class="ols-calendar ols-calendar2">';
        datePicker += '<div class="calendar-container"><div class="calendar-month">'
          + datepicker_langs[this.options.lang].months[month] + '</div><div class="calendar-year">'
          + year + '</div><div class="calendar-nav-next-month"></div>';
        datePicker += '<div class="calendar-header"><div class="calendar-date">'
          + this._getDayName(0, true) + '</div><div class="calendar-date">' + this._getDayName(1, true) + '</div><div class="calendar-date">'
          + this._getDayName(2, true) + '</div><div class="calendar-date">' + this._getDayName(3, true) + '</div><div class="calendar-date">'
          + this._getDayName(4, true) + '</div><div class="calendar-date">' + this._getDayName(5, true) + '</div><div class="calendar-date">'
          + this._getDayName(6, true) + '</div></div><div class="calendar-body"></div></div></div>';
        // end ols-datepicker
        datePicker += '</div><div class="ols-datepicker-selected is-empty"></div></div></div>';

        // Add datePickerVanTot HTML element to Document Body
        document.body.insertAdjacentHTML('beforeend', datePicker);

        // Save pointer to each datePicker element for later use
        this.datePickerContainer = document.getElementById(this._id);
        this.datePickerCalendar = this.datePickerContainer.querySelector('.ols-calendar1');
        this.datePickerCalendarNavMonth = this.datePickerCalendar.querySelector('.ols-calendar1 .calendar-month');
        this.datePickerCalendarNavYear = this.datePickerCalendar.querySelector('.ols-calendar1 .calendar-year');
        this.datePickerCalendarNavPreviousMonth = this.datePickerCalendar.querySelector('.calendar-nav-previous-month');
        this.datePickerCalendarHeader = this.datePickerCalendar.querySelector('.ols-calendar1 .calendar-header');
        this.datePickerCalendarBody = this.datePickerCalendar.querySelector('.ols-calendar1 .calendar-body');

        // month 2
        this.datePickerCalendar2 = this.datePickerContainer.querySelector('.ols-calendar2');
        this.datePickerCalendarNavMonth2 = this.datePickerCalendar2.querySelector('.ols-calendar2 .calendar-month');
        this.datePickerCalendarNavYear2 = this.datePickerCalendar2.querySelector('.ols-calendar2 .calendar-year');
        this.datePickerCalendarNavNextMonth = this.datePickerCalendar2.querySelector('.calendar-nav-next-month');
        this.datePickerCalendarBody2 = this.datePickerCalendar2.querySelector('.ols-calendar2 .calendar-body');
        // selected date(s)
        this.datePickerSelected = this.datePickerContainer.querySelector('.ols-datepicker-selected');
      }

      /**
       * Bind all events
       * @method _bindEvents
       * @return {void}
       */
    }, {
      key: '_bindEvents',
      value: function _bindEvents() {
        var _this2 = this;

        // Bind month navigation events
        this.datePickerCalendarNavPreviousMonth.addEventsListener(this._clickEvent, function (e) {
          e.preventDefault();
          _this2.prevMonth();
        });
        this.datePickerCalendarNavNextMonth.addEventsListener(this._clickEvent, function (e) {
          e.preventDefault();
          _this2.nextMonth();
        });
      }

      /**
       * Bind events on each Day item
       * @method _bindDaysEvents
       * @return {void}
       */
    }, {
      key: '_bindDaysEvents',
      value: function _bindDaysEvents() {
        var _this3 = this;

        [].forEach.call(this.datePickerCalendarDays, function (calendarDay) {
          calendarDay.addEventsListener(_this3._clickEvent, function (e) {
            e.preventDefault();
            if (e.currentTarget.dataset.date && !e.currentTarget.classList.contains('is-disabled')) {
              var date = e.currentTarget.dataset.date.split('-');
              var _date = _slicedToArray(date, 3),
                year = _date[0],
                month = _date[1],
                day = _date[2];

              if (typeof _this3.options.onSelect != 'undefined' && _this3.options.onSelect != null && _this3.options.onSelect) {
                var dates = '';
                if (_this3.options.startDate) {
                  dates = _this3.options.startDate.getFullYear() + '-'
                    + _this3.options.startDate.getMonth() + '-'
                    + _this3.options.startDate.getDate() + '#' + e.currentTarget.dataset.date.toString();
                  _this3.hoverDate = null;
                } else {
                  dates = e.currentTarget.dataset.date.toString() + '#';
                }
                // emit value
                _this3.options.onSelect(dates);
              }
              _this3.element.value = _this3._getFormatedDate(new Date(year, month, day), _this3.options.dateFormat);
            }
          });

          if (_this3.options.startDate && !_this3.options.endDate) {
            calendarDay.addEventsListener(_this3._hoverEvent, function (e) {
              e.preventDefault();
              if (e.currentTarget.dataset.date && !e.currentTarget.classList.contains('is-hoverend') && !e.currentTarget.classList.contains('is-disabled')) {
                if (_this3.datePickerCalendarBody && _this3.options.startDate && !_this3.options.endDate) {
                  // extra check
                  if (!_this3.options.dateHover || (_this3.options.dateHover && _this3.options.dateHover !== e.currentTarget.dataset.date)) {
                    _this3.options.dateHover = e.currentTarget.dataset.date;
                    _this3.datePickerCalendarBody.innerHTML = '';
                    _this3.datePickerCalendarBody2.innerHTML = '';
                    var date = e.currentTarget.dataset.date.split('-');
                    var _date = _slicedToArray(date, 3);
                    _this3.hoverDate = new Date(_date[0], _date[1], _date[2]);
                    _this3._renderDays();
                  }
                }
              }
            });
            calendarDay.addEventsListener(_this3._hoverEndEvent, function (e) {
              e.preventDefault();
              if (_this3.datePickerCalendarBody) {
                _this3.datePickerCalendarBody.innerHTML = '';
                _this3.datePickerCalendarBody2.innerHTML = '';
                _this3.hoverDate = null;
                _this3._renderDays();
              }
            });
          }
        });
      }

      /**
       * Get localized day name
       * @method renderDayName
       * @param  {[type]}      day          [description]
       * @param  {Boolean}     [abbr=false] [description]
       * @return {[type]}                   [description]
       */
    }, {
      key: '_getDayName',
      value: function _getDayName(day, abbr) {
        if (abbr === undefined) {
          abbr = false;
        }
        if (abbr) {
          day += datepicker_langs[this.options.lang].weekStart;
        }

        while (day >= 7) {
          day -= 7;
        }
        return abbr ? datepicker_langs[this.options.lang].weekdaysShort[day] : datepicker_langs[this.options.lang].weekdays[day];
      }
    }, {
      key: '_renderDay',
      value: function _renderDay(day, month, year, isSelected, isRangeStart, isInRange, isRangeEnd, isToday, isDisabled, isPrevMonth, isNextMonth, isHovered, isHoverDay, isHoverEnd) {
        return '<div data-date="' + this._parseDataDate(day, month, year, isPrevMonth, isNextMonth) + '" class="calendar-date' + (isSelected ? ' is-active' : '')
          + ((isDisabled || isPrevMonth || isNextMonth) ? ' is-disabled' : '') + (isHovered ? ' is-hover' : '') + (isHoverDay ? ' is-hoverday' : '')
          + (isHoverEnd ? ' is-hoverend' : '') + (isInRange ? ' is-in-range' : '') + (isRangeStart ? ' is-range-start' : '') + (isRangeEnd ? ' is-range-end' : '')
          + '"><button class="date-item' + (isToday && !(isDisabled || isPrevMonth || isNextMonth) ? ' is-today' : '') + ((isPrevMonth || isNextMonth) ? ' is-hidden' : '') + '">' + day + '</button></div>';
      }
    }, {
      key: '_parseDataDate',
      value: function (day, month, year, isPrevMonth, isNextMonth) {
        if (isPrevMonth) {
          if (month == 0) {
            month = 11;
            year = year - 1;
          } else {
            month = month - 1;
          }
        }
        if (isNextMonth) {
          if (month == 11) {
            month = 0;
            year = year + 1;
          } else {
            month = month + 1;
          }
        }
        return year + '-' + month + '-' + day;
      }
    }, {
      key: '_renderDays',
      value: function _renderDays() {
        // eerste maand
        this.datePickerCalendarBody.insertAdjacentHTML('beforeend', this._parseBody(this.month, this.year));
        // een maand later
        var month2 = this.month + 1,
          year2 = this.year;
        if (month2 > 11) {
          year2 += Math.floor(Math.abs(month2) / 12);
          month2 -= 12;
        }
        this.datePickerCalendarBody2.insertAdjacentHTML('beforeend', this._parseBody(month2, year2));
        this.datePickerCalendarDays = this.datePickerContainer.querySelectorAll('.calendar-date');

        if (this.options.startDate) {
          this.datePickerSelected.innerHTML = '';
          this.datePickerSelected.classList.remove('is-empty');
          var selected = this._getFormatedDate(this.options.startDate, 'd M yyyy') + ' t/m ';
          if (this.options.endDate) {
            selected += this._getFormatedDate(this.options.endDate, 'd M yyyy');
          } else {
            selected += 'kies de einddatum';
          }
          this.datePickerSelected.insertAdjacentHTML('beforeend', selected);
        } else {
          this.datePickerSelected.classList.add('is-empty');
        }
        this._bindDaysEvents();
      }

      /**
       * Navigate to the previous month and regenerate calendar
       * @method prevMonth
       * @return {void}
       */

    }, {
      key: 'prevMonth',
      value: function prevMonth() {
        this.month -= 1;
        this._refreshCalendar();
      }
    }, {
      key: '_disablePrevMonth',
      value: function _disablePrevMonth() {
        this.datePickerCalendarNavPreviousMonth.classList.add('hide');
      }
    }, {
      key: '_enablePrevMonth',
      value: function _enablePrevMonth() {
        this.datePickerCalendarNavPreviousMonth.classList.remove('hide');
      }

      /**
       * Navigate to the next month and regenerate calendar
       * @method nextMonth
       * @return {}
       */
    }, {
      key: 'nextMonth',
      value: function nextMonth() {
        this.month += 1;
        this._refreshCalendar();
      }
    }, {
      key: '_disableNextMonth',
      value: function _disableNextMonth() {
        this.datePickerCalendarNavNextMonth.classList.add('hide');
      }
    }, {
      key: '_enableNextMonth',
      value: function _enableNextMonth() {
        this.datePickerCalendarNavNextMonth.classList.remove('hide');
      }

      /**
       * Show datePickerVanTot HTML Component
       * @method show
       * @return {void}
       */
    }, {
      key: 'show',
      value: function show() {
        var reset = false;
        // Set the startDate to the input value
        if (this.element.value) {
          if (this.options.startDate) {
            // Als endDate gevuld dan reset range
            if (this.options.endDate) {
              this.options.startDate = null;
              this.options.endDate = null;
              reset = true;

              if (typeof this.options.onReset != 'undefined' && this.options.onReset != null && this.options.onReset) {
                this.options.onReset();
              }
            } else {
              // startDate gevuld, check of endDate na startDate
              var endDate = this._parseDate(this.element.value);
              if (endDate > this.options.startDate) {
                this.options.endDate = endDate;
              } else {
                this.options.startDate = null;
                reset = true;

                if (typeof this.options.onReset != 'undefined' && this.options.onReset != null && this.options.onReset) {
                  this.options.onReset();
                }
              }
            }
          } else {
            this.options.startDate = this._parseDate(this.element.value);
          }
        }
        if (this.options.startDate == null && !reset) {
          this.month = new Date().getMonth();
          this.year = new Date().getFullYear();
        }
        this._refreshCalendar();
      }

      /**
       * Refresh calendar with new year/month days
       * @method _refreshCalendar
       * @return {[type]}        [description]
       */
    }, {
      key: '_refreshCalendar',
      value: function _refreshCalendar() {
        if (this.month < 0) {
          this.year -= Math.ceil(Math.abs(this.month) / 12);
          this.month += 12;
        }
        if (this.month > 11) {
          this.year += Math.floor(Math.abs(this.month) / 12);
          this.month -= 12;
        }

        this.datePickerCalendarNavMonth.innerHTML = datepicker_langs[this.options.lang].months[this.month];
        this.datePickerCalendarNavYear.innerHTML = this.year;
        this.datePickerCalendarBody.innerHTML = '';

        // een maand later
        var month2 = this.month + 1,
          year2 = this.year;
        if (month2 > 11) {
          year2 += Math.floor(Math.abs(month2) / 12);
          month2 -= 12;
        }
        this.datePickerCalendarNavMonth2.innerHTML = datepicker_langs[this.options.lang].months[month2];
        this.datePickerCalendarNavYear2.innerHTML = year2;
        this.datePickerCalendarBody2.innerHTML = '';

        var minMonth = 0,
          minYear = 0,
          maxMonth = 12,
          maxYear = 9999;

        if (this.options.startDate) {
          if (this.options.endDate) {
            // van en tot datum gekozen
            if (this.options.minDateVan) {
              minMonth = this.options.minDateVan.getMonth();
              minYear = this.options.minDateVan.getFullYear();
            }
            if (this.options.maxDateTot) {
              maxMonth = this.options.maxDateTot.getMonth();
              maxYear = this.options.maxDateTot.getFullYear();
            }
          } else {
            // van datum gekozen
            if (this.options.minDateTot) {
              minMonth = this.options.minDateTot.getMonth();
              minYear = this.options.minDateTot.getFullYear();
            }
            if (this.options.maxDateTot) {
              maxMonth = this.options.maxDateTot.getMonth();
              maxYear = this.options.maxDateTot.getFullYear();
            }
          }
        } else {
          // nog geen keuze gemaakt
          if (this.options.minDateVan) {
            minMonth = this.options.minDateVan.getMonth();
            minYear = this.options.minDateVan.getFullYear();
          }
          if (this.options.maxDateVan) {
            maxMonth = this.options.maxDateVan.getMonth();
            maxYear = this.options.maxDateVan.getFullYear();
          }
        }

        if (this.year <= minYear && this.month <= minMonth) {
          this._disablePrevMonth();
        } else {
          this._enablePrevMonth();
        }

        if (this.year >= maxYear && this.month >= maxMonth) {
          this._disableNextMonth();
        } else {
          this._enableNextMonth();
        }
        this._renderDays();
        return this;
      }

      /**
       * Destroy datePickerVanTot
       * @method destroy
       * @return {[type]} [description]
       */
    }, {
      key: 'destroy',
      value: function destroy() {
        this.datePickerCalendar.parentNode.removeChild(this.datePickerCalendar);
        this.datePickerCalendar2.parentNode.removeChild(this.datePickerCalendar2);
      }

      /**
       * Returns date according to passed format
       * @method _getFormatedDate
       * @param {Date}   dt     Date object
       * @param {String} format Format string
       *      d    - day of month
       *      dd   - 2-digits day of month
       *      D    - day of week
       *      m    - month number
       *      mm   - 2-digits month number
       *      M    - short month name
       *      MM   - full month name
       *      yy   - 2-digits year number
       *      yyyy - 4-digits year number
       */
    }, {
      key: '_getFormatedDate',
      value: function _getFormatedDate(dt, format) {
        if (dt != null) {
          var items = {
            d: dt.getDate(),
            dd: dt.getDate(),
            D: dt.getDay(),
            m: dt.getMonth() + 1,
            mm: dt.getMonth() + 1,
            M: dt.getMonth(),
            MM: dt.getMonth(),
            yy: dt.getFullYear().toString().substr(-2),
            yyyy: dt.getFullYear()
          };

          items.dd < 10 && (items.dd = '0' + items.dd);
          items.mm < 10 && (items.mm = '0' + items.mm);
          items.D = datepicker_langs[this.options.lang].weekdays[items.D ? items.D - 1 : 6];
          items.M = datepicker_langs[this.options.lang].monthsShort[items.M];
          items.MM = datepicker_langs[this.options.lang].months[items.MM];

          return format.replace(/(?:[dmM]{1,2}|D|yyyy|yy)/g, function (m) {
            return typeof items[m] !== 'undefined' ? items[m] : m;
          });
        }
      }

      /**
       * Parse Body string based on month
       * @method _parseBody
       * @param  {String}   month
       * @param  {String}   year
       * @return {String}   body for one month
       */

    }, {
      key: '_parseBody',
      value: function _parseBody(month, year) {
        if (month == undefined || year == undefined) {
          return null;
        }
        var now = new Date();
        var days = '';

        var numberOfDays = this._getDaysInMonth(year, month),
          before = new Date(year, month, 1).getDay();

        // Get start day from options
        if (datepicker_langs[this.options.lang].weekStart > 0) {
          before -= datepicker_langs[this.options.lang].weekStart;
          if (before < 0) {
            before += 7;
          }
        }

        var cells = numberOfDays + before,
          after = cells;
        while (after > 7) {
          after -= 7;
        }

        cells += 7 - after;
        for (var i = 0; i < cells; i++) {
          var day = new Date(year, month, 1 + (i - before)),
            isSelected = false,
            isToday = this._compareDates(day, now),
            isDisabled = false,
            isPrevMonth = false,
            isNextMonth = false,
            isRangeStart = false,
            isInRange = false,
            isRangeEnd = false,
            isHovered = false,
            isHoverDay = false,
            isHoverEnd = false,
            minDate = null,
            maxDate = null,
            dayMin,
            dayPlus;

          day.setHours(6, 0, 0, 0);

          if (this.options.startDate) {
            if (this.options.endDate) {
              // van en tot datum gekozen
              minDate = this.options.minDateVan;
              maxDate = this.options.maxDateTot;
            } else {
              // van datum gekozen
              minDate = this.options.minDateTot;
              maxDate = this.options.maxDateTot;
            }
          } else {
            // nog geen keuze gemaakt
            minDate = this.options.minDateVan;
            maxDate = this.options.maxDateVan;
          }

          if (day.getMonth() !== month || (minDate && day.getTime() < minDate.getTime()) || (maxDate && day.getTime() > maxDate.getTime())) {
            isDisabled = true;
          }
          if (day.getMonth() !== month) {
            if (day.getMonth() < month || day.getFullYear() < year) {
              isPrevMonth = true;
            } else {
              isNextMonth = true;
            }
          }

          // range
          if (this.options.startDate) {
            if (!isPrevMonth && !isNextMonth) {
              if (this._compareDates(day, this.options.startDate)) {
                isSelected = true;
                if (this.options.endDate) {
                  isRangeStart = true;
                }
              }
              if (this.options.endDate && this._compareDates(day, this.options.endDate)) {
                isSelected = true;
                isRangeEnd = true;
              }
            }
            if (this.options.endDate && !isSelected) {
              // isInRange als:
              // - datum groter dan de gekozen startdatum en datum kleiner dan de gekozen einddatum OF
              // - maand van de gekozen einddatum na de maand van de gekozen startdatum ligt EN
              //   * vorige maand en datum (evt plus 7 dagen) groter dan de gekozen startdatum EN datum kleiner gelijk de gekozen einddatum OF
              //   * volgende maand en datum groter dan de gekozen startdatum EN datum (evt minus 7 dagen) kleiner dan de gekozen einddatum
              if (day > this.options.startDate && day < this.options.endDate && !isPrevMonth && !isNextMonth) {
                isInRange = true;
              } else {
                if (this.options.endDate.getMonth() > this.options.startDate.getMonth() || this.options.endDate.getFullYear() > this.options.startDate.getFullYear()) {
                  dayPlus = new Date(day);
                  dayMin = new Date(day);
                  if (this.options.startDate.getDate() > 15) {
                    dayPlus.setDate(dayPlus.getDate() + 7);
                  }
                  if (this.options.endDate.getDate() < 15) {
                    dayMin.setDate(dayMin.getDate() - 7);
                  }
                  if (isPrevMonth && dayPlus > this.options.startDate && day <= this.options.endDate) {
                    isInRange = true;
                  }
                  if (isNextMonth && day > this.options.startDate && dayMin < this.options.endDate) {
                    isInRange = true;
                  }
                }
              }
            }
          }
          // hover
          if (this.hoverDate && !isRangeStart) {
            if (!isPrevMonth && !isNextMonth) {
              if (this.hoverDate > this.options.startDate && this.options.startDate <= day && day <= this.hoverDate) {
                isHovered = true;
              }
              if (this._compareDates(day, this.options.startDate)) {
                isHoverDay = true;
              }
              if (this._compareDates(day, this.hoverDate)) {
                isHoverEnd = true;
              }
            } else {
              if (this.hoverDate.getMonth() > this.options.startDate.getMonth() || this.hoverDate.getFullYear() > this.options.startDate.getFullYear()) {
                dayPlus = new Date(day);
                dayMin = new Date(day);

                if (this.options.startDate.getDate() > 15) {
                  dayPlus.setDate(dayPlus.getDate() + 7);
                }
                if (this.hoverDate.getDate() < 15) {
                  dayMin.setDate(dayMin.getDate() - 7);
                }
                if (isPrevMonth && dayPlus > this.options.startDate && day <= this.hoverDate) {
                  isHovered = true;
                }
                if (isNextMonth && day > this.options.startDate && dayMin < this.hoverDate) {
                  isHovered = true;
                }
              }
            }
          }

          days += this._renderDay(day.getDate(), month, year, isSelected, isRangeStart, isInRange, isRangeEnd, isToday, isDisabled, isPrevMonth, isNextMonth, isHovered, isHoverDay, isHoverEnd);
        }
        return days;
      }

      /**
       * Parse Date string based on the Date Format given
       * @method _parseDate
       * @param  {String}   dateString          Date string to parse
       * @param  {String}   [format=undefined] Date Format
       * @return {Date}                         Date Object initialized with Date String based on the Date Format
       */
    }, {
      key: '_parseDate',
      value: function _parseDate(dateString, format) {
        if (dateString == undefined) {
          return null;
        }
        var date = new Date();
        date.setHours(6, 0, 0, 0);

        if (!format) {
          format = this.options.dateFormat;
        }

        var formatPattern = /((?:mm?)|(?:dd?)|(?:yyy?y?))[^0-9]((?:mm?)|(?:dd?)|(?:yyy?y?))[^0-9]((?:mm?)|(?:dd?)|(?:yyy?y?))/i;
        var datePattern = /(\d+)[^0-9](\d+)[^0-9](\d+)/i;

        var matchFormat = formatPattern.exec(format);
        if (matchFormat) {
          var matchDate = datePattern.exec(dateString);
          if (matchDate) {
            var indexYear = matchFormat.findIndex(function (value) {
              if (value.substring(0, 1) === 'y' && value.length <= 4) { return true; }
            });
            var indexMonth = matchFormat.findIndex(function (value) {
              if (value.substring(0, 1) === 'm' && value.length <= 2) { return true; }
            });
            var indexDay = matchFormat.findIndex(function (value) {
              if (value.substring(0, 1) === 'd' && value.length <= 2) { return true; }
            });
            date.setFullYear(matchDate[indexYear]);
            date.setDate(1); // tijdelijk naar 1, om problemen met 31
            date.setMonth(matchDate[indexMonth] - 1);
            date.setDate(matchDate[indexDay]);
          }
        }

        return date;
      }

      /**
       * Check if given year is LeapYear or not
       * @method _isLeapYear
       * @param  {Integer}   year Year to check
       * @return {Boolean}        True if LeapYear then False
       */
    }, {
      key: '_isLeapYear',
      value: function _isLeapYear(year) {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
      }

      /**
       * Get the number of days in month
       * @method _getDaysInMonth
       * @param  {Integer}       year  Year to check if we are facing a leapyear or not
       * @param  {Integer}       month Month for which we want to know the amount of days
       * @return {Integer}              Days amount
       */
    }, {
      key: '_getDaysInMonth',
      value: function _getDaysInMonth(year, month) {
        return [31, this._isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      }

      /**
       * Compare two dates
       * @method _compareDates
       * @param  {Date}     a First date to compare
       * @param  {Date}     b Second Date to compare with
       * @return {Boolean}    True if dates are equal then false
       */
    }, {
      key: '_compareDates',
      value: function _compareDates(a, b) {
        // weak date comparison
        a.setHours(6, 0, 0, 0);
        b.setHours(6, 0, 0, 0);
        return a.getTime() === b.getTime();
      }
    }]);

    return datePickerVanTot;
  }();

  return datePickerVanTot;
});